// https://vuex.vuejs.org/en/mutations.html

import { set, toggle } from "@/utils/vuex";

export default {
  setWhiteLabel (state, payload) {
    state.whitelabel = payload;
    localStorage.setItem("current-whitelabel", payload.name);
  },
};
 